export default "__VITE_ASSET__INEZwrnZ__"